import AnalyticsService from '@root/core/src/services/analytics-service';
import Button, { BUTTON_SIZE_SMALL, BUTTON_VARIANT_SECONDARY } from '@root/core/src/components/button';
import Header from '@root/core/src/components/header';
import PropTypes from '@root/vendor/prop-types';
import React, { Component } from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import { StyleSheet } from '@root/core/src/utils/styles';
import { withRouter } from '@root/core/src/components/route';

class LandingHeader extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    showSignInButton: PropTypes.bool.isRequired,
  }

  _handleSignInClick = () => {
    AnalyticsService.trackClickEvent('LANDING_HEADER', 'SIGNIN');
    this.props.history.push('/landing/login/email');
  };

  _renderSignInButton() {
    if (!this.props.showSignInButton) {
      return null;
    }

    return (
      <Button
        css={styles.login}
        onClick={this._handleSignInClick}
        size={BUTTON_SIZE_SMALL}
        variant={BUTTON_VARIANT_SECONDARY}
      >
        Sign in
      </Button>
    );
  }

  render() {
    return (
      <Header>
        {this._renderSignInButton()}
      </Header>
    );
  }
}

export default withRouter(LandingHeader);

const styles = StyleSheet.create({
  login: {
    display: 'none',
    width: 115,
    marginTop: 0,
    ...Responsive.md({
      display: 'inline-block',
    }),
  },
});
